<template>
    <calculator-form
        ref="form"
        :title="title"
    >
        <v-layout
            wrap
            slot="form"
        >
            <v-flex
                xs12
            >
                <v-select
                    class="title-branding custom-select"
                    :items="products"
                    v-model="client.product"
                    label="Plan type"
                    item-text="Name"
                    item-value="ProductMasterID"
                    filled
                    :rules="[
                        v => !!v || 'Plan type is required'
                    ]"
                    :disabled="checking"
                    @change="updateClientProduct"
                ></v-select>
            </v-flex>
            <v-flex
                xs12
                sm12
                md6
            >
                <v-slider
                    :class="isMobile ? '' : 'mt-6'"
                    class="custom-slider"
                    v-model="client.age"
                    thumb-label="always"
                    :thumb-size="35"
                    :min="age_range.min"
                    :max="age_range.max"
                    :disabled="checking"
                    inverse-label
                    :label="client.age.toString()"
                    :hint="'Age ('.toUpperCase() + age_range.min + '-' + age_range.max + ')'"
                    persistent-hint
                    :rules="[
                        v => !!v || 'Age is required',
                        v => !isNaN(v) || 'Age needs to be a number',
                        v => v <= age_range.max || 'Age cannot be more than ' + age_range.max,
                        v => v >= age_range.min || 'Age cannot be less than ' + age_range.min,
                        v => client.retire_age && (client.retire_age - client.age) > 5 || 'Client within 5 years of retirement age',
                    ]"
                    :color="$vuetify.theme.dark ? 'accent' : 'primary'"
                ></v-slider>
            </v-flex>
            <v-flex
                xs12
                sm12
                md6
            >
                <v-select
                    class="title-branding custom-select"
                    :items="[60, 65]"
                    v-model="client.retire_age"
                    label="Retirement age"
                    filled
                    :rules="[
                        v => !!v || 'Retirement age is required'
                    ]"
                    :disabled="checking"
                    @change="updateFormValidation"
                ></v-select>
            </v-flex>
        </v-layout>
        <v-card-actions v-if="kpError">
            <v-alert
                type="error"
                icon="$mdiAlert"
                class="w-full title-branding caption"
            >
                {{ kpError }}
            </v-alert>
        </v-card-actions>
        <v-card-actions
            slot="actions"
        >
            <v-spacer></v-spacer>
            <v-btn
                class="custom-button"
                type="button"
                color="accent"
                :disabled="!formIsValid"
                :loading="checking"
                @click="goToStepTwo"
                :small="isMobile"
            >
                Next
                <v-icon
                    dark
                    small
                >
                    $mdiChevronRight
                </v-icon>
            </v-btn>
        </v-card-actions>
    </calculator-form>
</template>
<script>
import CalculatorForm from './../../Global/Form';

import KeyPlanMixin from "./../keyplan";

export default {
    name: "KeyPlan-Step-One",

    mixins: [
        KeyPlanMixin
    ],

    components: {
        CalculatorForm,
    },

    props: {
        'title': {
            type: String,
            default: ''
        }
    },

    data() {
        return {}
    },

    methods: {
        productFilter(item, queryText, itemText) {
            const textOne = item.ProductGroup.toLowerCase();
            const textTwo = item.Name.toLowerCase();

            const searchText = queryText.toLowerCase();

            return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1;
        },
        updateClientProduct() {
            if (this.client.product !== null) {
                this.products.forEach((product) => {
                    if (parseInt(product.ProductMasterID) === parseInt(this.client.product)) {
                        this.$store.commit('keyplan/setMaxAge', (product.MaxEntryAge - 1));
                        this.$store.commit('keyplan/setMinAge', (product.MinEntryAge - 1));

                        this.updateFormValidation();
                    }
                });
            }
        },
        updateFormValidation() {
            this.$refs.form.validateForm();

            this.$store.dispatch('keyplan/getBenefits');
        },
        decrementAge() {
            if (this.client.age > this.age_range.min) {
                this.client.age--;
            }
        },
        incrementAge() {
            if (this.client.age < this.age_range.max) {
                this.client.age++;
            }
        },
        goToStepTwo() {
            if (this.kpError) {
                return;
            }

            this.$refs.form.validateForm()
                .then((response) => {
                    if (!this.formIsValid) {
                        return;
                    }

                    this.$store.commit('calculators/setCurrentStep', 2);
                });
        }
    }
}
</script>
